// extracted by mini-css-extract-plugin
module.exports = {"center":"_3niT6PwuAclmfwHkvkxLn9"};